import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.find.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import isObject from 'lodash/isObject';
import CategoryCheckboxFilter from '~/components/organisms/Category/CategoryCheckboxFilter.vue';
import CategoryDimensionsFilter from '~/components/organisms/Category/CategoryDimensionsFilter.vue';
import Accordion from '~/components/molecules/Accordion.vue';
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/cross.svg';

var CategoryRangeFilter = function CategoryRangeFilter() {
  return import('~/components/organisms/Category/CategoryRangeFilter.vue');
};

export default {
  name: 'CategoryFiltersList',
  components: {
    CategoryCheckboxFilter: CategoryCheckboxFilter,
    CategoryDimensionsFilter: CategoryDimensionsFilter,
    CategoryRangeFilter: CategoryRangeFilter,
    Accordion: Accordion
  },
  props: {
    activeFilters: {
      type: Array,
      required: true
    },
    filters: {
      type: Array,
      required: true
    },
    desktopLayer: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selectedFilter: null
    };
  },
  computed: {
    validFilters: function validFilters() {
      return this.filters && this.filters.length > 0 ? this.filters.filter(function (f) {
        return f.facets;
      }) : [];
    }
  },
  methods: {
    getFilterActiveFacetsLabel: function getFilterActiveFacetsLabel(filter) {
      var _this = this;

      var filterActivefacets = null;

      if (filter.name === 'price.amount') {
        var priceFacet = this.activeFilters.find(function (f) {
          return f.filter === 'price' && f.label;
        });
        return priceFacet ? priceFacet.label : '';
      }

      if (filter.name === 'dimensions') {
        var dimensionFilters = ['width', 'height', 'depth'];
        filterActivefacets = this.activeFilters.filter(function (f) {
          return dimensionFilters.includes(f.filter);
        });
        filterActivefacets = filterActivefacets.map(function (e) {
          return "".concat(_this.$t(e.filter), ": ").concat(e.label);
        });
        return filterActivefacets ? filterActivefacets.map(function (e) {
          return e.trim();
        }).join(', ') : '';
      }

      filterActivefacets = this.activeFilters.filter(function (f) {
        return f.filter === filter.name && f.label && f.label.trim();
      });
      return filterActivefacets ? filterActivefacets.map(function (e) {
        return e.label.trim();
      }).join(', ') : '';
    },
    getFilterLabel: function getFilterLabel(filter) {
      if (isObject(filter.label)) return filter.label.label;
      return filter.label;
    }
  }
};